import React from "react"
import { SELECTOR_CATALOG, SELECTOR_CATEGORIES } from "./selector-catalog"

type Props = {
  value: string
  onChange: (value: string) => void
  /** Tree mapping names; lets the author pick a {{nodeName}} reference. */
  treeNodeMappingNames?: string[]
  placeholder?: string
}

const SelectorPicker: React.FC<Props> = ({
  value,
  onChange,
  treeNodeMappingNames = [],
  placeholder = "#elementId or {{nodeName}}",
}) => {
  const isCustom =
    value !== "" &&
    !SELECTOR_CATALOG.some((e) => e.selector === value) &&
    !treeNodeMappingNames.some((n) => `{{${n}}}` === value)

  return (
    <div className="flex flex-col gap-1">
      <select
        value={isCustom ? "__custom__" : value}
        onChange={(e) => {
          if (e.target.value === "__custom__") {
            // keep current value (will be edited below)
            if (!value) onChange("")
            return
          }
          onChange(e.target.value)
        }}
        className="border rounded px-2 py-1 text-sm">
        <option value="">— pick a target —</option>
        {(Object.keys(SELECTOR_CATEGORIES) as Array<keyof typeof SELECTOR_CATEGORIES>).map(
          (cat) => {
            const entries = SELECTOR_CATALOG.filter((e) => e.category === cat)
            if (entries.length === 0) return null
            return (
              <optgroup key={cat} label={SELECTOR_CATEGORIES[cat]}>
                {entries.map((e) => (
                  <option key={e.selector} value={e.selector}>
                    {e.label} ({e.selector})
                  </option>
                ))}
              </optgroup>
            )
          },
        )}
        {treeNodeMappingNames.length > 0 && (
          <optgroup label="Tree mappings">
            {treeNodeMappingNames.map((n) => (
              <option key={n} value={`{{${n}}}`}>{`{{${n}}}`}</option>
            ))}
            {treeNodeMappingNames.map((n) => (
              <option
                key={`${n}-container`}
                value={`#tree-item-{{${n}}}-container`}>{`#tree-item-{{${n}}}-container`}</option>
            ))}
          </optgroup>
        )}
        <option value="__custom__">Custom (free text)…</option>
      </select>
      {isCustom && (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="border rounded px-2 py-1 text-sm font-mono"
        />
      )}
    </div>
  )
}

export default SelectorPicker
